import {useEffect, useState, useCallback} from "react";
import firebase from "firebase/compat/app";
import fb from "../firebase";


export interface UseFirestoreOptions {
  enabled?: boolean;
  useDebug?: boolean;
}

interface UseFirestoreProps {
  args?: any;
  query: (args?: any) => firebase.firestore.Query;
  queryKey: string;
  options?: UseFirestoreOptions;
}

export const useFirestore = <T>(props: UseFirestoreProps): [T[], boolean] => {
  const {options, query, queryKey, args} = props;
  const enabled = options && options.enabled !== undefined ? options.enabled : true;
  const useDebug = options && options.useDebug !== undefined ? options.useDebug : false;
  const [_enabled, setEnabled] = useState(false);
  const [_queryKey, setQueryKey] = useState<string>();
  const [_query, setQuery] = useState<firebase.firestore.Query>();
  const [isLoading, setIsLoading] = useState(false);
  const [colecao, setColecao] = useState<T[]>([]);

  const debugHook = useCallback((msg: string, data: any) => {
    if (useDebug) {
      console.log(msg, data);
    }
  }, [useDebug]);

  useEffect(() => {
    if (enabled && (queryKey !== _queryKey)) {
      debugHook('useFirestore SET', {queryKey, enabled});
      setQueryKey(queryKey);
      setQuery(query(args));
    }
    // debugHook('useFirestore SET PASS', {queryKey, _queryKey, enabled});

    setEnabled(enabled);
  }, [query, queryKey, enabled, _query, debugHook, args, _queryKey]);

  useEffect(() => {
    if (!_enabled || !_query) {
      debugHook('useFirestore SKIP', {_queryKey, _enabled});
      return;
    }

    setIsLoading(true);
    let onRemoveListener: () => void;
    const removeListener = () => {
      debugHook(`useFirestore removeListener`, _queryKey);
      if (onRemoveListener) {
        debugHook('useFirestore removeListener called', _queryKey);
        onRemoveListener();
      }
    }

    onRemoveListener = _query.onSnapshot(snap => {
      debugHook('useFirestore onSnapshot', {_queryKey, count: snap.size});
      const _colecao = fb.col(snap);
      setIsLoading(false);
      setColecao(_colecao);
    });
    debugHook('useFirestore ON', {_queryKey});
    return removeListener;
  }, [_queryKey, _enabled, _query, debugHook]);

  return [colecao, isLoading];
};


// TODO: refac para reutilizar o hook useFirestore
export const useFirestoreSnap = (props: UseFirestoreProps): [firebase.firestore.QuerySnapshot | undefined, boolean] => {
  const {options, query, queryKey, args} = props;
  const enabled = options && options.enabled !== undefined ? options.enabled : true;
  const [_enabled, setEnabled] = useState(false);
  const [_queryKey, setQueryKey] = useState<string>();
  const [_query, setQuery] = useState<firebase.firestore.Query>();
  const [isLoading, setIsLoading] = useState(false);
  const [snap, setSnap] = useState<firebase.firestore.QuerySnapshot>();

  useEffect(() => {
    if (enabled && (queryKey !== _queryKey)) {
      // console.log('useFirestoreSnap SET', {queryKey, enabled});
      setQueryKey(queryKey);
      setQuery(query(args));
    }

    setEnabled(enabled);
  }, [query, queryKey, enabled, _query, args, _queryKey]);

  useEffect(() => {
    if (!_enabled || !_query) {
      // console.log('useFirestoreSnap SKIP', _queryKey);
      return;
    }

    setIsLoading(true);
    let onRemoveListener: () => void;
    const removeListener = () => {
      // console.log(`useFirestoreSnap removeListener`, _queryKey);
      if (onRemoveListener) {
        // console.log('useFirestoreSnap removeListener called', _queryKey);
        onRemoveListener();
      }
    }

    onRemoveListener = _query.onSnapshot(snap => {
      // console.log('useFirestoreSnap onSnapshot', _queryKey);
      setIsLoading(false);
      setSnap(snap);
    });
    // console.log('useFirestoreSnap RUN', _queryKey);
    return removeListener;
  }, [_queryKey, _enabled, _query]);

  return [snap, isLoading];
};